/* Modulo: Marquee Wave — slides SVG textPath startOffset along the wave.
   The Liquid SSR fills each path with repeats of the phrase unit; a hidden
   off-path measuring node carries ONE unit, because Firefox excludes glyphs
   past the path end from getComputedTextLength on a textPath.
   JS off / reduced motion = static curved text, no scroll. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE_MQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  if (REDUCE_MQ && REDUCE_MQ.matches) return;

  var MOBILE_MQ = window.matchMedia ? window.matchMedia('(max-width: 860px)') : null;
  var FINE_MQ = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;

  function initSection(root) {
    if (root.dataset.mwInit === '1') return;
    root.dataset.mwInit = '1';

    var speed = parseFloat(root.getAttribute('data-mw-speed')) || 95;
    var dir = root.getAttribute('data-mw-dir') === 'right' ? 1 : -1;
    var pauseEnabled = root.getAttribute('data-mw-pause') === '1';

    /* One state per breakpoint SVG; active = matches the current media. */
    var states = [];
    var svgs = root.querySelectorAll('.modulo-mw__svg');
    for (var i = 0; i < svgs.length; i++) {
      var tp = svgs[i].querySelector('[data-mw-tp]');
      var mn = svgs[i].querySelector('[data-mw-measure]');
      if (!tp || !mn) continue;
      states.push({
        tp: tp,
        measure: mn,
        isMobile: svgs[i].classList.contains('modulo-mw__svg--m'),
        unit: 0,
        offset: 0,
      });
    }
    if (!states.length) return;

    var paused = false;
    var reduced = false;
    var onscreen = true;
    var rafId = 0;
    var last = null;
    var io = null;

    function active(s) {
      return MOBILE_MQ ? s.isMobile === MOBILE_MQ.matches : !s.isMobile;
    }

    function measure(s) {
      if (s.unit > 0) return true;
      var len = 0;
      try { len = s.measure.getComputedTextLength(); } catch (e) { return false; }
      if (len > 0) s.unit = len;
      return s.unit > 0;
    }

    function frame(t) {
      rafId = requestAnimationFrame(frame);
      if (last === null) { last = t; return; }
      var dt = (t - last) / 1000;
      last = t;
      if (dt > 0.25) dt = 0.25; /* tab was throttled; do not jump */
      if (document.hidden || !onscreen || paused || reduced) return;
      for (var i = 0; i < states.length; i++) {
        var s = states[i];
        if (!active(s) || !measure(s)) continue;
        s.offset += dir * speed * dt;
        s.offset = ((s.offset % s.unit) - s.unit) % s.unit;
        s.tp.setAttribute('startOffset', s.offset);
      }
    }

    if (pauseEnabled) {
      if (FINE_MQ && FINE_MQ.matches) {
        root.addEventListener('mouseenter', function () { paused = true; });
        root.addEventListener('mouseleave', function () { paused = false; });
      } else {
        /* Coarse pointers: tap toggles, so touch users can stop the motion. */
        root.addEventListener('pointerdown', function () { paused = !paused; });
      }
    }

    if (REDUCE_MQ && REDUCE_MQ.addEventListener) {
      REDUCE_MQ.addEventListener('change', function (e) { reduced = e.matches; });
    }

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        onscreen = entries[entries.length - 1].isIntersecting;
      }, { rootMargin: '80px' });
      io.observe(root);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        for (var i = 0; i < states.length; i++) states[i].unit = 0;
      });
    }

    root.__mwStop = function () {
      cancelAnimationFrame(rafId);
      if (io) io.disconnect();
      states.length = 0;
    };
    rafId = requestAnimationFrame(frame);
  }

  function bootstrap() {
    var els = document.querySelectorAll('[data-modulo-mw]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  if (!window.__moduloMwWired) {
    window.__moduloMwWired = true;
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector('[data-modulo-mw]');
      if (root) initSection(root);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target && e.target.querySelector('[data-modulo-mw]');
      if (root && root.__mwStop) root.__mwStop();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
